export default __webpack_public_path__ + "media/images/nzws_theme_background-115653d4ebec6ab1704d193c9e3ee508.png";